import * as moment from 'moment/moment';

import {isPeriodNeutralized} from "./isPeriodNeutralized";

// derives the list's initial queryParams from the route's :params segment
// (e.g. navigating back from an order detail), or starts empty on a fresh visit
export function getInitialQueryParams(props) {
    const paramsFromUrl = props.match?.params?.params;

    return paramsFromUrl ? decodeURIComponent(paramsFromUrl) : '';
}

function getDefaultDates() {
    const date = new Date();
    const endDate = moment(date);

    date.setDate(date.getDate() - 7);
    const startDate = moment(date);

    return {startDate, endDate};
}

// the compact date picker only understands "both set" or "both cleared"
// (see QueryParamsSync/DateRangePickerContext.clearDates). A search (or a
// receipt value filter) spans every date, so it never needs a period; otherwise fall back to the default
// 7-day range instead of leaving it unset, so queryParams can be seeded with
// it up front and QueryParamsSync's mount-time effect has nothing new to add
// (avoids the "fetched twice: once with no period, once with the default
// period" double load)
export function getInitialDates(queryParams) {
    const params = new URLSearchParams(queryParams);

    if (isPeriodNeutralized(params)) {
        return {restoredStartDate: null, restoredEndDate: null};
    }

    const after = params.get('createdAt[after]');
    const before = params.get('createdAt[before]');

    if (after && before) {
        return {
            restoredStartDate: moment(after, 'YYYY-M-D HH:mm:ss'),
            restoredEndDate: moment(before, 'YYYY-M-D HH:mm:ss')
        };
    }

    const {startDate, endDate} = getDefaultDates();

    return {restoredStartDate: startDate, restoredEndDate: endDate};
}

export function withDefaultDatesIfNeeded(queryParams, startDate, endDate) {
    const params = new URLSearchParams(queryParams);

    if (isPeriodNeutralized(params) || params.has('createdAt[after]')) {
        return queryParams;
    }

    params.set('createdAt[after]', startDate.clone().startOf('day').format('YYYY-M-D HH:mm:ss'));
    params.set('createdAt[before]', endDate.clone().endOf('day').format('YYYY-M-D HH:mm:ss'));

    return params.toString();
}
